import {MonthlyReportState} from '../state/monthlyReportState';
import {Fetch_All_Region_Data1, Fetch_All_Monthly_Report_Data,Fetch_All_Users_Data,Fetch_All_Alarm_Data} from '../action/monthlyReportAction';

export function MonthlyReportReducer(state = MonthlyReportState, action) {
   
    switch(action.type){
        case Fetch_All_Region_Data1:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                regionList : action.regionList
            })
        case Fetch_All_Monthly_Report_Data:
            return Object.assign({}, state,{
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                lifeGuardAlarm : action.lifeGuardAlarm,
            })
            case Fetch_All_Users_Data:
            return Object.assign({}, state,{
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                usersList : action.usersList,
            })
            case Fetch_All_Alarm_Data:
            return Object.assign({}, state,{
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                alarmList : action.alarmList,
            })
        default:
            return state
    }
}